import { log } from '@/log'
import { ItemKind } from '@/models/item/kind'

import AbstractValue from '@/models/app-config/behavior/abstract-value'
import ItemListFilter, { RawItemListFilter } from './item-list/filter'
import ItemOnItemList, { RawItemOnItemList } from './item-list/item'

export interface RawItemList {
  item: RawItemOnItemList
  filter: RawItemListFilter
  layout: string
}

export default class ItemList extends AbstractValue<RawItemList> {
  get item(): ItemOnItemList {
    return new ItemOnItemList(this.raw.item)
  }

  get filter(): ItemListFilter {
    return new ItemListFilter(this.raw.filter)
  }

  get layout(): ItemKind {
    const defaultLayout: ItemKind = 'default'
    const rawLayout = this.raw.layout || defaultLayout

    const validLayouts: ItemKind[] = ['default', 'contact-lens']

    if (!validLayouts.includes(rawLayout as ItemKind)) {
      log.error(`Invalid ItemKind value: "${rawLayout}". Falling back to default.`, {
        rawLayout,
        validLayouts,
        brandConfig: this.raw,
      })

      return defaultLayout
    }

    return rawLayout as ItemKind
  }
}
